import React, { useEffect, useState } from "react";
import Header from "../../Header";
import "../../assets/css/alie.css";
import Pagination from "react-js-pagination";
import DateRangePicker from "react-bootstrap-daterangepicker";
//import 'bootstrap-daterangepicker/daterangepicker.css';
import "./../../bootstrap/css/daterangepicker.css";
import moment from "moment";
import { BsSearch } from "react-icons/bs";

// const getLastWeekRange = () => {
//     const startOfLastWeek = moment().startOf('isoWeek').subtract(1, 'weeks'); // Monday
//     const endOfLastWeek = moment().startOf("isoWeek").subtract(1, "weeks").add(4, "days"); // Sunday
//     return {
//         start: startOfLastWeek.format("YYYY-MM-DD"),
//         end: endOfLastWeek.format("YYYY-MM-DD")
//     };

// };

const getLastWeekRange = () => {
    const today = moment();
    const startOfLastWeek = today.clone().startOf('isoWeek').subtract(1, 'weeks'); // Last Monday
    const endOfLastWeek = today.isoWeekday() === 1
        ? startOfLastWeek.clone().add(3, 'days') // Thursday (Mon + 3)
        : startOfLastWeek.clone().add(4, 'days'); // Friday (Mon + 4)

    return {
        start: startOfLastWeek.format("YYYY-MM-DD"),
        end: endOfLastWeek.format("YYYY-MM-DD")
    };
};

const { start, end } = getLastWeekRange();

const EmployeeActivityInsights = () => {
    const [allData, setAllData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const perPage = 20;
    const [searchQuery, setSearchQuery] = useState("");
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [loading, setLoading] = useState(false);

    const [startDate, setStartDate] = useState(start);
    const [endDate, setEndDate] = useState(end);

    const fetchData = async (customStart, customEnd) => {
        setLoading(true);
        try {
            const params = new URLSearchParams();
            if (customStart) params.append("start_date", customStart);
            if (customEnd) params.append("end_date", customEnd);

            const response = await fetch(`${process.env.REACT_APP_CRM}/admin/employee/productivity?${params}`);
            const result = await response.json();
            const data = result.data || [];

            setAllData(data);
            setFilteredData(data);

        } catch (err) {
            console.error("Failed to fetch activity data", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(start, end); // Initial fetch with previous week's range
    }, []);

    // // 🔍 Search
    // useEffect(() => {
    //     if (searchQuery) {

    //         const query = searchQuery.toLowerCase();

    //         const filtered = allData.filter((emp) => {
    //             const name = emp.name || "";
    //             const email = emp.email || "";
    //             return name.toLowerCase().includes(query) || email.toLowerCase().includes(query);
    //         });

    //         setFilteredData(filtered);
    //         setCurrentPage(1);
    //     }
    // }, [searchQuery, allData]);

    useEffect(() => {
        if (searchQuery) {
            const query = searchQuery.toLowerCase();
            const filtered = allData.filter((emp) => {
                const name = emp.name || "";
                const email = emp.email || "";
                return name.toLowerCase().includes(query) || email.toLowerCase().includes(query);
            });

            setFilteredData(filtered);
        } else {
            // ✅ Reset to full data when search is cleared
            setFilteredData(allData);
        }

        setCurrentPage(1);
    }, [searchQuery, allData]);


    // 🔀 Sorting
    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });

        const sorted = [...filteredData].sort((a, b) => {
            const aVal = a[key] !== undefined && a[key] !== null ? a[key] : "";
            const bVal = b[key] !== undefined && b[key] !== null ? b[key] : "";

            if (typeof aVal === "string") {
                return direction === "asc"
                    ? aVal.localeCompare(bVal)
                    : bVal.localeCompare(aVal);
            } else {
                return direction === "asc" ? aVal - bVal : bVal - aVal;
            }
        });

        setFilteredData(sorted);
    };

    // 📄 Pagination
    const paginatedData = filteredData.slice(
        (currentPage - 1) * perPage,
        currentPage * perPage
    );

    const handleDateApply = (event, picker) => {

        const start = moment(picker.startDate);
        const end = moment(picker.endDate);

        const diffInMonths = end.diff(start, 'months', true); // fractional month difference

        if (diffInMonths > 3) {
            alert("You can only select a range up to 3 months.");
            return;
        }

        const newStart = moment(picker.startDate).format("YYYY-MM-DD");
        const newEnd = moment(picker.endDate).format("YYYY-MM-DD");

        setStartDate(newStart);
        setEndDate(newEnd);
        fetchData(newStart, newEnd);
    };

    return (
        <div>
            <Header brecum_name="ActivityInsights" brecum_page="Activity Insights" />
            <div className="right_col">
                <div className="customer-wrap">
                    <div className="page-top" style={{
                        paddingRight: "0px"
                    }}>
                        <div className="container" style={{
                            paddingRight: "5px"
                        }}>
                            <div className="row align-items-center mb-3">
                                <div className="col-md-6">
                                    <div class="mt-10">
                                        <div class="d-flex align-items-center">
                                            <h2>Activity Insights</h2>
                                            <span class="badge-blue">{moment(startDate).format('MMMM D, YYYY') +
                                                ' - ' +
                                                moment(endDate).format('MMMM D, YYYY')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">

                                    <DateRangePicker
                                        initialSettings={{
                                            startDate: moment(startDate),
                                            endDate: moment(endDate),
                                            showDropdowns: true,
                                            autoUpdateInput: false,
                                            linkedCalendars: false,
                                            maxDate: moment().subtract(3, 'days'),
                                        }}
                                        onApply={handleDateApply}
                                    >
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={'From Date -  To Date'}
                                        />
                                    </DateRangePicker>


                                </div>
                                <div className="col-md-3 text-right" style={{ paddingRight: "20px" }}>

                                    <div className="lct-form-group" style={{ height: "37px" }}>
                                        <button
                                            type="submit"
                                            style={{
                                                background: "#fff",
                                                padding: "8px 3px 8px 11px",
                                            }}
                                        >
                                            <BsSearch />
                                        </button>

                                        <input
                                            type="text"
                                            className="form-control input-f"
                                            placeholder="Search by name"
                                            value={searchQuery}
                                            autoComplete="off"
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            style={{
                                                padding: " 0 0 0 5px",
                                                height: "35px",
                                                borderRadius: "6px",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="body-content">
                        <div className="employee-list table-wrap mt-10">
                            {loading ? (
                                <p>Loading...</p>
                            ) : paginatedData.length === 0 ? (
                                <p>No Activity Insights found for this period.</p>
                            ) : (
                                <table>
                                    <thead>
                                        {/* <tr>
                                            <th onClick={() => handleSort("name")}>Employee {sortConfig.key === "name" && (sortConfig.direction === "asc" ? "▲" : "▼")}</th>
                                            <th onClick={() => handleSort("emails_sent")}>Emails Sent {sortConfig.key === "emails_sent" && (sortConfig.direction === "asc" ? "▲" : "▼")}</th>
                                            <th onClick={() => handleSort("meetings_attended")}>Meetings Attended {sortConfig.key === "meetings_attended" && (sortConfig.direction === "asc" ? "▲" : "▼")}</th>
                                            <th onClick={() => handleSort("total_hours_spent")}>Hours in Meeting {sortConfig.key === "total_hours_spent" && (sortConfig.direction === "asc" ? "▲" : "▼")}</th>
                                            <th onClick={() => handleSort("average_minutes_late")}>Avg. Minutes Late {sortConfig.key === "average_minutes_late" && (sortConfig.direction === "asc" ? "▲" : "▼")}</th>
                                        </tr> */}

                                        <tr>
                                            <th>Employee</th>
                                            <th>Emails Sent</th>
                                            <th>Meetings Attended </th>
                                            <th >Hours in Meeting </th>
                                            <th >Avg. Minutes Late</th>
                                            <th >Number of Chats (28 days)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paginatedData.map((emp) => (
                                            <tr key={emp.id}>
                                                <td>
                                                    <div className="emps_details">
                                                        <a href={`/viewEmployee/${emp.id}`} className="d-flex align-items-center" style={{ textDecoration: "none", color: "inherit" }}>
                                                            <div class="emps_pic">
                                                                <img
                                                                    src={emp.profile_image}
                                                                    alt={emp.name}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    style={{
                                                                        width: "40px",
                                                                        maxHeight: "40px",
                                                                        objectFit: "contain",
                                                                        marginRight: "10px"
                                                                    }}
                                                                />
                                                            </div>
                                                            {emp.name}
                                                        </a>
                                                    </div>
                                                </td>
                                                <td>{emp.emails_sent !== undefined && emp.emails_sent !== null ? emp.emails_sent : 0}</td>
                                                <td>{emp.meetings_attended !== undefined && emp.meetings_attended !== null ? emp.meetings_attended : 0}</td>
                                                <td>{typeof emp.total_hours_spent === "number" ? emp.total_hours_spent.toFixed(2) : "0.00"}</td>

                                                <td>{emp.average_minutes_late !== undefined && emp.average_minutes_late !== null ? emp.average_minutes_late : 0}</td>

                                                <td>{emp.chat_messages_sent_last28days !== undefined && emp.chat_messages_sent_last28days !== null ? emp.chat_messages_sent_last28days : 0}</td>

                                                {/* <td>
                                                    <a
                                                        href={`/employees/productivity/details?email=${encodeURIComponent(emp.email)}&start_date=${startDate}&end_date=${endDate}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ textDecoration: "underline", color: "#007bff" }}
                                                    >
                                                        {emp.average_minutes_late !== undefined && emp.average_minutes_late !== null
                                                            ? emp.average_minutes_late
                                                            : 0}
                                                    </a>
                                                </td> */}


                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}

                            {filteredData.length > perPage && (
                                <div className="d-flex mu-pagination justify-content-between align-items-center mt-3">
                                    <div className="mu-pagination__info">
                                        <p className="mu-pagination__info-text">
                                            Showing {Math.min((currentPage - 1) * perPage + 1, filteredData.length)} to {Math.min(currentPage * perPage, filteredData.length)} of {filteredData.length} entries
                                        </p>
                                    </div>
                                    <div className="mu-pagination">
                                        <Pagination
                                            activePage={currentPage}
                                            itemsCountPerPage={perPage}
                                            totalItemsCount={filteredData.length}
                                            pageRangeDisplayed={5}
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            onChange={setCurrentPage}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default EmployeeActivityInsights;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/EmployeeActivityInsights.js